(function () {
  'use strict';

  console.log('[BCS] Script loaded');

  function extractBrand(title, words) {
    if (!title) return null;
    return title.trim().split(/\s+/).slice(0, words).join(' ');
  }

  function esc(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function formatMoney(price) {
    var amount = parseFloat(price);
    if (isNaN(amount)) return '';
    return amount.toLocaleString('de-DE', {
      style: 'currency',
      currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR'
    });
  }

  function fetchCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }

  function fetchBrandProducts(brand) {
    var url = '/search/suggest.json?q=' + encodeURIComponent(brand) + '&resources[type]=product&resources[limit]=12';
    return fetch(url, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (d) { return (d && d.resources && d.resources.results && d.resources.results.products) || []; });
  }

  function fetchProductDetails(handle) {
    return fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .catch(function () { return null; });
  }

  function renderSkeleton(el, heading) {
    el.innerHTML =
      '<div class="bcs-wrap">' +
        '<p class="bcs-heading">' + esc(heading) + '</p>' +
        '<div class="bcs-track">' +
          '<div class="bcs-card bcs-card--skeleton"><div class="bcs-skel-img"></div><div class="bcs-skel-line" style="width:70%"></div><div class="bcs-skel-line" style="width:45%"></div></div>' +
          '<div class="bcs-card bcs-card--skeleton"><div class="bcs-skel-img"></div><div class="bcs-skel-line" style="width:60%"></div><div class="bcs-skel-line" style="width:40%"></div></div>' +
          '<div class="bcs-card bcs-card--skeleton"><div class="bcs-skel-img"></div><div class="bcs-skel-line" style="width:75%"></div><div class="bcs-skel-line" style="width:50%"></div></div>' +
        '</div>' +
      '</div>';
  }

  function groupVariantOptions(variants, options) {
    return options.map(function (optName, idx) {
      var seen = {};
      var values = [];
      variants.forEach(function (v) {
        var val = v['option' + (idx + 1)];
        if (val && !seen[val]) {
          seen[val] = true;
          values.push({ value: val, variantId: v.id, available: v.available });
        }
      });
      return { name: optName, values: values };
    });
  }

  function findVariantId(variants, selections) {
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      var match = true;
      for (var key in selections) {
        if (v[key] !== selections[key]) { match = false; break; }
      }
      if (match) return { id: v.id, available: v.available };
    }
    return null;
  }

  function updateSelections(card, variants, options, changedEl, eventType) {
    if (changedEl.classList.contains('bcs-pill') && eventType === 'click') {
      var row = changedEl.parentNode;
      row.querySelectorAll('.bcs-pill').forEach(function (p) { p.classList.remove('bcs-pill--active'); });
      changedEl.classList.add('bcs-pill--active');
    }
    var selections = {};
    options.forEach(function (opt, idx) {
      var activePill = card.querySelector('.bcs-pill[data-opt-idx="' + idx + '"].bcs-pill--active');
      var select = card.querySelector('.bcs-select[data-opt-idx="' + idx + '"]');
      if (activePill) selections['option' + (idx + 1)] = activePill.dataset.val;
      else if (select) selections['option' + (idx + 1)] = select.value;
      else if (variants[0]) selections['option' + (idx + 1)] = variants[0]['option' + (idx + 1)];
    });
    var found = findVariantId(variants, selections);
    var btn = card.querySelector('.bcs-btn');
    if (btn) {
      if (found) {
        btn.dataset.variantId = found.id;
        btn.disabled = !found.available;
        btn.textContent = found.available ? 'Hinzufügen' : 'Nicht verfügbar';
        btn.classList.remove('bcs-btn--done');
      } else {
        btn.disabled = true;
        btn.textContent = 'Nicht verfügbar';
      }
    }
  }

  function addToCart(btn, card, el) {
    if (btn.disabled) return;
    var variantId = btn.dataset.variantId;
    if (!variantId) return;
    btn.disabled = true;
    btn.textContent = '…';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
    }).then(function (r) {
      if (r.ok) {
        btn.textContent = '✓ Hinzugefügt';
        btn.classList.add('bcs-btn--done');
        setTimeout(function () {
          card.style.transition = 'opacity 0.3s ease';
          card.style.opacity = '0';
          setTimeout(function () { card.remove(); }, 300);
        }, 800);
        fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          document.dispatchEvent(new CustomEvent('theme:cart:updated', { bubbles: true }));
          window.dispatchEvent(new CustomEvent('cart-update', { bubbles: true }));

setTimeout(function () {
  var el = document.querySelector('brand-cross-sell');
  if (el) initElement(el);
}, 400);
          var countEls = document.querySelectorAll('cart-count, .cart-count');
          for (var i = 0; i < countEls.length; i++) {
            countEls[i].textContent = cart.item_count;
          }
        });
      } else {
        btn.disabled = false;
        btn.textContent = 'Hinzufügen';
      }
    }).catch(function () {
      btn.disabled = false;
      btn.textContent = 'Hinzufügen';
    });
  }

  function renderCard(p, product, el) {
    var card = el.querySelector('.bcs-card[data-handle="' + p.handle + '"]');
    if (!card) return;
    var variants = product ? product.variants : [];
    var options = product ? product.options : [];
    var hasVariants = variants.length > 1;
    var selections = {};
    options.forEach(function (opt, idx) {
      if (variants[0]) selections['option' + (idx + 1)] = variants[0]['option' + (idx + 1)];
    });
    var grouped = hasVariants ? groupVariantOptions(variants, options) : [];
    var optionsHtml = '';
    if (hasVariants && grouped.length > 0) {
      grouped.forEach(function (opt, optIdx) {
        if (opt.values.length <= 5) {
          var pills = opt.values.map(function (v) {
            var active = selections['option' + (optIdx + 1)] === v.value ? ' bcs-pill--active' : '';
            var unavailable = !v.available ? ' bcs-pill--unavail' : '';
            return '<button type="button" class="bcs-pill' + active + unavailable + '" data-opt-idx="' + optIdx + '" data-val="' + esc(v.value) + '">' + esc(v.value) + '</button>';
          }).join('');
          optionsHtml += '<div class="bcs-option-row">' + pills + '</div>';
        } else {
          var optionItems = opt.values.map(function (v) {
            var sel = selections['option' + (optIdx + 1)] === v.value ? ' selected' : '';
            return '<option value="' + esc(v.value) + '"' + sel + '>' + esc(v.value) + '</option>';
          }).join('');
          optionsHtml += '<div class="bcs-option-row"><select class="bcs-select" data-opt-idx="' + optIdx + '">' + optionItems + '</select></div>';
        }
      });
    }
    var initialVariant = findVariantId(variants, selections);
    var initialVid = initialVariant ? initialVariant.id : (variants[0] ? variants[0].id : null);
    var initialAvail = initialVariant ? initialVariant.available : true;
    var linkEl = card.querySelector('.bcs-card__link');
    card.innerHTML =
      (linkEl ? linkEl.outerHTML : '') +
      (optionsHtml ? '<div class="bcs-options">' + optionsHtml + '</div>' : '') +
      '<button class="bcs-btn"' + (initialAvail ? '' : ' disabled') + ' data-variant-id="' + (initialVid || '') + '" data-handle="' + esc(p.handle) + '">' + (initialAvail ? 'Hinzufügen' : 'Nicht verfügbar') + '</button>';
    if (hasVariants) {
      card.querySelectorAll('.bcs-pill, .bcs-select').forEach(function (optEl) {
        optEl.addEventListener('click', function () { updateSelections(card, variants, options, optEl, 'click'); });
        optEl.addEventListener('change', function () { updateSelections(card, variants, options, optEl, 'change'); });
      });
    }
    var btn = card.querySelector('.bcs-btn');
    if (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        addToCart(btn, card, el);
      });
    }
  }

  function renderProducts(el, heading, brand, products, cartHandles, brandWords, maxProducts) {
    var filtered = products.filter(function (p) {
      if (cartHandles.indexOf(p.handle) !== -1) return false;
      if (p.vendor) return p.vendor.toLowerCase() === brand.toLowerCase();
      var tb = extractBrand(p.title, brandWords);
      return tb && tb.toLowerCase() === brand.toLowerCase();
    }).slice(0, maxProducts);

    if (filtered.length === 0) { el.innerHTML = ''; return; }

    var cards = filtered.map(function (p) {
      var imageUrl = (p.featured_image && p.featured_image.url)
        ? p.featured_image.url + '&width=400'
        : p.image ? p.image + '&width=400' : null;
      var imgHtml = imageUrl
        ? '<img src="' + esc(imageUrl) + '" alt="' + esc(p.title) + '" loading="lazy" class="bcs-img">'
        : '<div class="bcs-img bcs-img--placeholder"></div>';
      var price = p.price ? formatMoney(p.price) : '';
      return '<div class="bcs-card" data-handle="' + esc(p.handle) + '">' +
        '<a href="/products/' + esc(p.handle) + '" class="bcs-card__link" data-no-instant>' +
          '<div class="bcs-img-wrap">' + imgHtml + '</div>' +
          '<div class="bcs-info">' +
            '<p class="bcs-title">' + esc(p.title) + '</p>' +
            '<p class="bcs-price">' + price + '</p>' +
          '</div>' +
        '</a>' +
        '<button class="bcs-btn" data-handle="' + esc(p.handle) + '">Hinzufügen</button>' +
      '</div>';
    }).join('');

    el.innerHTML =
      '<div class="bcs-wrap">' +
        '<p class="bcs-heading">' + esc(heading) + '</p>' +
        '<div class="bcs-track">' + cards + '</div>' +
      '</div>';

    el.querySelectorAll('.bcs-btn').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        addToCart(btn, btn.closest('.bcs-card'), el);
      });
    });

    filtered.forEach(function (p) {
      fetchProductDetails(p.handle).then(function (product) {
        if (product) renderCard(p, product, el);
      });
    });
  }

  function initElement(el) {
    console.log('[BCS] initElement called');
    var brandWords = parseInt(el.getAttribute('data-brand-words') || '2', 10);
    var maxProducts = parseInt(el.getAttribute('data-max-products') || '4', 10);
    var heading = el.getAttribute('data-heading') || 'Mehr von dieser Marke';
    fetchCart().then(function (cart) {
      console.log('[BCS] cart items:', cart ? cart.item_count : 'null');
      if (!cart || cart.item_count === 0) { el.innerHTML = ''; return; }
      var firstItem = cart.items[0];
      var brand = firstItem && (firstItem.vendor || extractBrand(firstItem.title, brandWords));
      console.log('[BCS] brand:', brand);
      if (!brand) { el.innerHTML = ''; return; }
      var cartHandles = cart.items.map(function (i) { return i.handle; });
      renderSkeleton(el, heading);
      fetchBrandProducts(brand).then(function (products) {
        renderProducts(el, heading, brand, products, cartHandles, brandWords, maxProducts);
      });
    }).catch(function (err) {
      console.warn('[BCS] error:', err);
      el.innerHTML = '';
    });
  }

  // Einmalig starten mit Guard
  var _started = false;

  // Einmalig starten mit Guard
var _started = false;

var _started = false;

function setup() {

  if (_started) return;

  var drawer = document.getElementById('cart-drawer');

  if (!drawer) return;

  _started = true;

  var debounceTimer = null;
  var wasOpen = false;
  var isRendering = false;

  function runInit() {

    if (isRendering) return;

    clearTimeout(debounceTimer);

    debounceTimer = setTimeout(function () {

      var el = document.querySelector('brand-cross-sell');

      if (!el) return;

      isRendering = true;

      Promise.resolve(initElement(el))
        .finally(function () {

          setTimeout(function () {
            isRendering = false;
          }, 500);

        });

    }, 250);
  }

  // Nur Klassen beobachten
  new MutationObserver(function () {

    var isOpen =
      drawer.classList.contains('show-close-cursor') ||
      drawer.classList.contains('active') ||
      drawer.classList.contains('is-open');

    // Nur beim echten Öffnen triggern
    if (isOpen && !wasOpen) {
      runInit();
    }

    wasOpen = isOpen;

  }).observe(drawer, {
    attributes: true,
    attributeFilter: ['class']
  });

  // Cart Updates
  document.documentElement.addEventListener('cart:refresh', function () {

    if (
      drawer.classList.contains('show-close-cursor') ||
      drawer.classList.contains('active') ||
      drawer.classList.contains('is-open')
    ) {
      runInit();
    }

  });

  document.addEventListener('theme:cart:updated', function () {

    if (
      drawer.classList.contains('show-close-cursor') ||
      drawer.classList.contains('active') ||
      drawer.classList.contains('is-open')
    ) {
      runInit();
    }

  });

  window.addEventListener('cart-update', function () {

    if (
      drawer.classList.contains('show-close-cursor') ||
      drawer.classList.contains('active') ||
      drawer.classList.contains('is-open')
    ) {
      runInit();
    }

  });

  // Initial
  runInit();
}

setTimeout(setup, 0);
setTimeout(setup, 500);
setTimeout(setup, 1500);
window.addEventListener('load', setup);

})();